export const streamConnectMessages = {
  'zh-CN': {
    entry: '接入直播', title: '如何接入直播',
    step1Title: '打开小组件', step1: '打开后，拖动窗口边缘调整大小。',
    open: '打开小组件', opening: '正在打开', openFailed: '打开失败，请允许浏览器使用画中画后重试。',
    unsupported: '请使用桌面版 Chrome 或 Edge 打开小组件。',
    step2Title: '选一个背景色', step2: '选与文字、图标不同的纯色，方便直播工具去掉背景。',
    copyColor: '复制色值', copied: '已复制', copyFailed: '复制失败，请手动复制色值。',
    solidNeeded: '当前背景带有透明度，请选择不透明的纯色用于抠色。',
    step3Title: '在直播工具中添加小组件',
    capture: '添加“窗口捕获”，选择“枫记”小组件窗口。',
    keyColor: '裁掉标题栏和底部操作栏，添加“色键”或“抠色”滤镜，选中上面的背景色即可。',
    note: '直播时保持主页面和小组件开启。',
    done: '知道了',
  },
  en: {
    entry: 'Connect to stream', title: 'How to add your widget to a stream',
    step1Title: 'Open the widget', step1: 'Drag the window edges to resize it.',
    open: 'Open widget', opening: 'Opening', openFailed: 'Could not open the widget. Allow picture-in-picture in your browser and retry.',
    unsupported: 'Use desktop Chrome or Edge to open the widget.',
    step2Title: 'Pick a background color', step2: 'Choose a solid color different from the text and icons so your streaming tool can remove it.',
    copyColor: 'Copy color', copied: 'Copied', copyFailed: 'Copy failed. Copy the color value manually.',
    solidNeeded: 'This background has transparency. Choose an opaque solid color for keying.',
    step3Title: 'Add the widget in your streaming tool',
    capture: 'Add Window Capture and select the “Maple Log” widget window.',
    keyColor: 'Crop out the title bar and bottom controls, add a Chroma Key or Color Key filter, and match the background color above.',
    note: 'Keep the main page and widget open while streaming.',
    done: 'Got it',
  },
} as const
